// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import "channels";

Rails.start();
ActiveStorage.start();
require("jquery");
require("jquery-validation");
require("@fortawesome/fontawesome-free");

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// Show any pending toast messages stored in sessionStorage (e.g. after a page reload)
document.addEventListener("DOMContentLoaded", () => {
  const pendingToast = sessionStorage.getItem("pendingToast");
  if (pendingToast) {
    sessionStorage.removeItem("pendingToast");
    const toastr = require("toastr");
    require("toastr/build/toastr.min.css");
    const { message, type, redirectUrl } = JSON.parse(pendingToast);
    let handleToastClick;
    if (redirectUrl) {
      handleToastClick = () => {
        window.location.href = redirectUrl;
      };
    }

    toastr[type || "success"](message, "", {
      onclick: handleToastClick,
      timeOut: 10000,
      extendedTimeOut: 5000,
      closeButton: true
    });
  }

  document.addEventListener("click", (event) => {
    const dismissButton = event.target.closest?.("[data-ccw-dismiss-flash]");
    if (!dismissButton) return;

    const message = dismissButton.closest(".ccw-global-flash");
    const region = dismissButton.closest(".ccw-flash-region");
    message?.remove();

    if (region && !region.querySelector(".ccw-global-flash")) {
      region.remove();
    }
  });

  const accountMenu = document.querySelector("[data-ccw-account-menu]");
  const accountMenuTrigger = accountMenu?.querySelector("[aria-controls='account-menu']");
  const accountMenuPanel = accountMenu?.querySelector("#account-menu");

  const setAccountMenuOpen = (isOpen, { restoreFocus = false } = {}) => {
    if (!accountMenuTrigger || !accountMenuPanel) return;

    accountMenuTrigger.setAttribute("aria-expanded", String(isOpen));
    accountMenuTrigger.setAttribute(
      "aria-label",
      isOpen ? "Close account menu" : "Open account menu"
    );
    accountMenuPanel.hidden = !isOpen;
    accountMenu.classList.toggle("is-active", isOpen);
    if (restoreFocus) accountMenuTrigger.focus();
  };

  accountMenuTrigger?.addEventListener("click", () => {
    setAccountMenuOpen(accountMenuTrigger.getAttribute("aria-expanded") !== "true");
  });

  document.addEventListener("click", (event) => {
    if (accountMenu && !accountMenu.contains(event.target)) setAccountMenuOpen(false);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || accountMenuTrigger?.getAttribute("aria-expanded") !== "true")
      return;

    setAccountMenuOpen(false, { restoreFocus: true });
  });

  const mobileNavigation = document.querySelector("[data-ccw-mobile-nav]");
  const mobileNavigationTrigger = mobileNavigation?.querySelector("[data-ccw-mobile-nav-trigger]");
  const mobileNavigationPanel = mobileNavigation?.querySelector("[data-ccw-mobile-nav-panel]");

  const setMobileNavigationOpen = (isOpen, { restoreFocus = false } = {}) => {
    if (!mobileNavigationTrigger || !mobileNavigationPanel) return;

    mobileNavigationTrigger.setAttribute("aria-expanded", String(isOpen));
    mobileNavigationTrigger.classList.toggle("is-active", isOpen);
    mobileNavigationPanel.hidden = !isOpen;
    mobileNavigation.classList.toggle("is-open", isOpen);
    if (restoreFocus) mobileNavigationTrigger.focus();
  };

  mobileNavigationTrigger?.addEventListener("click", () => {
    setMobileNavigationOpen(mobileNavigationTrigger.getAttribute("aria-expanded") !== "true");
  });

  mobileNavigation?.querySelectorAll("[data-ccw-mobile-nav-close]").forEach((button) => {
    button.addEventListener("click", () => setMobileNavigationOpen(false, { restoreFocus: true }));
  });

  document.addEventListener("click", (event) => {
    if (mobileNavigation && !mobileNavigation.contains(event.target)) {
      setMobileNavigationOpen(false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      mobileNavigationTrigger?.getAttribute("aria-expanded") === "true"
    ) {
      setMobileNavigationOpen(false, { restoreFocus: true });
    }
  });

  window.matchMedia("(min-width: 769px)").addEventListener?.("change", (event) => {
    if (event.matches) setMobileNavigationOpen(false);
  });

  const disclosures = Array.from(document.querySelectorAll("details[data-ccw-disclosure]"));

  disclosures.forEach((disclosure) => {
    disclosure.addEventListener("toggle", () => {
      if (!disclosure.open) return;

      disclosures.forEach((otherDisclosure) => {
        if (otherDisclosure !== disclosure) otherDisclosure.open = false;
      });
    });
  });

  document.addEventListener("click", (event) => {
    disclosures.forEach((disclosure) => {
      if (disclosure.open && !disclosure.contains(event.target)) disclosure.open = false;
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    const openDisclosure = disclosures.find((disclosure) => disclosure.open);
    if (!openDisclosure) return;

    openDisclosure.open = false;
    openDisclosure.querySelector("summary")?.focus();
  });

  document.querySelectorAll("details[data-ccw-responsive-disclosure]").forEach((disclosure) => {
    const breakpoint = Number(disclosure.dataset.openBreakpoint || 1100);
    const mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`);
    const updateForViewport = (event) => {
      disclosure.open = event.matches;
    };

    updateForViewport(mediaQuery);
    mediaQuery.addEventListener?.("change", updateForViewport);
  });

  document.querySelectorAll("[data-ccw-client-avatar-image]").forEach((image) => {
    const fallback = image
      .closest(".ccw-client-avatar")
      ?.querySelector("[data-ccw-client-avatar-fallback]");
    const showFallback = () => {
      image.hidden = true;
      if (fallback) fallback.hidden = false;
    };

    if (image.complete && image.naturalWidth === 0) {
      showFallback();
    } else {
      image.addEventListener("error", showFallback, { once: true });
    }
  });
});
